import dayjs, { APP_TZ } from "../../../utils/dateTime";

// Check-in period (session) validation status
export const SESSION_STATUS = {
  VALID: { label: "Valid", tone: "green" },
  FOR_REVIEW: { label: "For review", tone: "amber" },
  APPROVED: { label: "Approved", tone: "green" },
  REJECTED: { label: "Rejected", tone: "red" },
};

// Day status (PATCH /attendance/:id). ON_LEAVE / HALF_DAY stick; the others
// are recalculated by the server from the sessions.
export const DAY_STATUSES = [
  { value: "PRESENT", label: "Present" },
  { value: "LATE", label: "Late" },
  { value: "ABSENT", label: "Absent" },
  { value: "HALF_DAY", label: "Half day" },
  { value: "ON_LEAVE", label: "On leave" },
];
export const DAY_STATUS_LABEL = Object.fromEntries(
  DAY_STATUSES.map((s) => [s.value, s.label]),
);

export const SOURCE_LABEL = {
  WEB: "Web",
  MOBILE: "Mobile",
  MANUAL: "Manual",
  BIOMETRIC: "Biometric",
};

/** "HH:mm" (Manila) of an ISO timestamp, for <input type="time">. */
export const timeValue = (iso) =>
  iso ? dayjs(iso).tz(APP_TZ).format("HH:mm") : "";

/** Plain date + "HH:mm" (Manila) → ISO timestamp. */
export const toManilaIso = (ymd, hhmm) =>
  ymd && hhmm
    ? dayjs.tz(`${ymd} ${hhmm}`, "YYYY-MM-DD HH:mm", APP_TZ).toISOString()
    : null;

/** 2600 → "2.6 km", 85 → "85 m". */
export const formatDistance = (meters) => {
  if (meters === null || meters === undefined) return "—";
  return meters >= 1000
    ? `${Math.round(meters / 100) / 10} km`
    : `${Math.round(meters)} m`;
};

export const formatHours = (h) =>
  h === null || h === undefined ? "—" : `${Math.round(h * 100) / 100} h`;

/** "In: Client A · Out: PO signed" from the session's check-in / check-out notes (else the old remarks). */
export const sessionNotes = (s) => {
  const parts = [
    s?.checkIn?.note && `In: ${s.checkIn.note}`,
    s?.checkOut?.note && `Out: ${s.checkOut.note}`,
  ].filter(Boolean);
  return parts.length ? parts.join(" · ") : s?.remarks || "";
};
